export default {
  hero: {
    eyebrow: "Das Basetao Spreadsheet Ressourcen-Hub",
    h1: "Basetao Spreadsheet: Produkte finden, Verkäufer vergleichen & smarter einkaufen",
    desc: "Entdecke organisierte Basetao Spreadsheet Ressourcen, Produkt-Funde, Verkäufer-Guides, QC-Infos, Versand-Guides, Bewertungen und praktische Kauftipps — alles in einem schnellen, durchsuchbaren Hub.",
    secondary: "Suchst du Produkte, prüfst du einen Verkäufer, vergleichst du Versandoptionen oder fragst du dich, ob Basetao seriös ist? Starte hier.",
    trust: "Unabhängige Ressource · Regelmäßig aktualisiert · Sicherheitsfokus · Mehrsprachig",
  },
  popular: {
    title: "Beliebte Themen",
  },
  value: {
    h2: "Alles, was du über Basetao wissen musst",
    sub: "Ein klarer, ehrlicher Ausgangspunkt für Produktrecherche, Verkäuferprüfung und sicheres Einkaufen.",
    card1: {
      title: "Spreadsheet-Ressourcen",
      desc: "Organisierte Produkt- und Kategorie-Ressourcen, um Funde schneller zu durchstöbern.",
    },
    card2: {
      title: "Verkäufer-Recherche",
      desc: "Lerne, Verkäufer zu vergleichen und Produktinfos vor der Bestellung zu bewerten.",
    },
    card3: {
      title: "QC-Guides",
      desc: "Verstehe QC-Fotos und was du prüfen solltest, bevor deine Artikel versendet werden.",
    },
    card4: {
      title: "Versand-Guides",
      desc: "Verstehe Gewicht, Volumengewicht, Versandlinien und Versicherung.",
    },
    card5: {
      title: "Unabhängige Bewertungen",
      desc: "Ausgewogene Artikel zu Erfahrung, Gebühren, Lager und Risiken.",
    },
    card6: {
      title: "Sicherheit zuerst",
      desc: "Erkenne gefälschte Links, irreführende Rabatte und riskante Zahlungsaufforderungen.",
    },
  },
  about: {
    h2: "Was ist Basetao Spreadsheet?",
    p1: "Basetao Spreadsheet bezeichnet die geteilten, organisierten Ressourcen, mit denen Menschen Produkte entdecken, Verkäufer vergleichen und Artikel vor der Bestellung im Blick behalten. Es macht aus verstreuten Produktlinks einen klareren Einkaufsplan.",
    p2: "Da sich Produktdaten und Verkäuferdetails schnell ändern, erklären wir vor allem, wie diese Ressourcen funktionieren und was du prüfen solltest — statt feste Preise oder Garantien zu nennen.",
  },
  review: {
    h2: "Ist Basetao seriös? Lies die Belege, bevor du kaufst",
    copy: "Unsere Inhalte trennen Fakten, Nutzerfeedback und redaktionelle Analyse, damit du selbst entscheiden kannst.",
    cta: "Basetao-Seriösitäts-Guide lesen",
  },
  shipping: {
    h2: "Basetao Versandkosten: Was beeinflusst den Preis wirklich?",
    copy: "Die Versandkosten können von Zielort, Paketgewicht, Volumengewicht, Versandlinie, Abmessungen, Versicherung und weiteren Faktoren abhängen.",
    cta: "Mehr zu Versandkosten erfahren",
  },
  safety: {
    h2: "Smarter einkaufen. Vor dem Bezahlen prüfen.",
    item1: "URLs vor dem Klicken prüfen",
    item2: "Passwörter niemals weitergeben",
    item3: "Verkäufer sorgfältig prüfen",
    item4: "Produktbelege prüfen",
    item5: "Coupons verifizieren",
    item6: "Versandbedingungen verstehen",
    cta: "Sicherheits-Checkliste öffnen",
  },
  articleSection: {
    h2: "Starte mit unserem ausführlichen Guide",
    copy: "Du fragst dich, ob Basetao seriös ist und wie du sicher bleibst? Lies unseren vollständigen, unabhängig verfassten Artikel.",
    cta: "Ganzen Artikel lesen",
  },
  guides: {
    h2: "Ausführliche Basetao-Guides",
    sub: "Zehn originale, unabhängig verfasste Guides zu Produkten, Verkäufern, QC, Versand, Lager, Coupons, Sicherheit und Vergleichen.",
  },
  cta: {
    h2: "Bereit, die Basetao Spreadsheet Ressourcen zu erkunden?",
    copy: "Starte mit dem Hauptguide und erkunde dann Produkte, Verkäufer, QC, Versand, Bewertungen und Sicherheit.",
    primary: "Basetao Spreadsheet",
    secondary: "Jetzt kaufen",
  },
};